export function composeOfferTitle(title: string): string {
  // Define the gender patterns
  const genderPatterns = [
    'f/h',
    'F/H',
    'h/f',
    'H/F',
    '(f/h)',
    '(F/H)',
    '(h/f)',
    '(H/F)',
  ]

  // Normalize the gender pattern to '(f/h)'
  let basic = title
    .replace(/\b(F\/H|h\/f|H\/F)\b/gi, 'f/h')
    .replace(/\((F\/H|h\/f|H\/F)\)/gi, 'f/h')

  // Remove duplicate gender patterns
  genderPatterns.forEach((pattern) => {
    const regex = new RegExp(
      `\\b(${pattern.replace(/[()]/g, '\\$&')})(\\s+\\1)+\\b`,
      'gi',
    )
    basic = basic.replace(regex, '$1')
  })

  // Check if the title contains any of the gender patterns
  const containsGenderPattern = genderPatterns.some((pattern) =>
    basic.toLowerCase().includes(pattern.toLowerCase()),
  )

  if (!containsGenderPattern) {
    // Append ' (f/h)' if no gender pattern is found
    return `${basic} f/h`
  }

  return basic
}
